module.exports = __webpack_public_path__ + "static/BLOG-PRINCIPAL-BG.4f547e75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Blog/BLOG-PRINCIPAL-BG.png
// module id = 496
// module chunks = 212839066777427